import { type IExpression } from '../IExpression.ts';
import { ExpressionRepository } from '../repository/ExpressionsRepository.ts';

export function expressionToString(expression: IExpression) {
  const toString = (expression: IExpression): string => {
    const expressionType = ExpressionRepository.get(expression.type);
    if (!expressionType) return '';
    return expressionType.toString(expression, toString);
  };

  return toString(expression);
}
